export default "__VITE_ASSET__C19lbejI__"